import { AutoComplete, Input } from "antd";
import React, { useState } from "react";

import "./stylesCustomAutoComplete.css";
import { SearchOutlined } from "@ant-design/icons";

function CustomAutoComplete({ allOptions = [], placeholder = "Search", handleChange, clearOptions }) {
  const [options, setOptions] = useState(allOptions);

  const onSearch = (searchText) => {
    if (!searchText) {
      setOptions(allOptions);
      clearOptions()
      return;
    }

    const filteredOptions = allOptions.filter((option) =>
      option.value.toLowerCase().includes(searchText.toLowerCase())
    );

    setOptions(filteredOptions);
  };

  const onSelect = (selectedValue) => {
    const selectedGame = allOptions.find(option => option.value === selectedValue);
    console.log(selectedGame)
    if (selectedGame) {
      handleChange(selectedGame.game_id);
    }
  };

  return (
    <AutoComplete
      className="custom-autocomplete"
      options={options}
      style={{
        width: "100%",
        bacground: "transparent",
      }}
      onSelect={onSelect}
      onSearch={onSearch}
      placeholder={placeholder}
    >
      <Input
        style={{
          background: "transparent",
        }}
        prefix={
          <SearchOutlined style={{ fontSize: "18px", color: "#92929E" }} />
        }
      />
    </AutoComplete>
  );
}

export default CustomAutoComplete;
